<ag-modal-base>
  <div class="content">
    @if (hasMismatch) {
      <div>
        <p>
          Some of the additional fields do not exist anymore. Please fix this
          before submitting by either adding the additional fields or clicking
          the clear button next to button for the fields that are not used
          anymore.
        </p>
        <div class="columns">
          <div class="column">
            <h3>Field</h3>
            <ul>
              @for (field of clearableFields; track field) {
                <li>
                  @if (clearAdditionalField !== field) {
                    <p class="control">
                      {{ field }}
                      <button
                        class="button has-text-danger is-small"
                        pTooltip="Clear"
                        tooltipPosition="top"
                        [disabled]="clearingAdditionalFieldData"
                        (click)="showClearAdditionalFieldData(field)"
                      >
                        <svg-icon src="/assets/icons/general/remove.svg" />
                      </button>
                    </p>
                  }
                  @if (clearAdditionalField === field) {
                    <p class="control">
                      <span class="has-text-danger">
                        Are you sure you want to clear <b>{{ field }}</b> from
                        the order's line items?
                      </span>
                      <button
                        (click)="removeField(field)"
                        class="button is-danger is-small pr-2"
                        [class.is-loading]="clearingAdditionalFieldData"
                        [disabled]="clearingAdditionalFieldData"
                      >
                        Clear
                      </button>
                      <button
                        class="button is-default is-small"
                        (click)="clearAdditionalField = null"
                        [disabled]="clearingAdditionalFieldData"
                      >
                        Cancel
                      </button>
                    </p>
                  }
                  <p></p>
                </li>
              }
            </ul>
          </div>
        </div>
      </div>
    } @else {
      <div>
        <p>All mismatches have been resolved. You can now save the order.</p>
      </div>
    }
  </div>
</ag-modal-base>
